import React,{useRef, useState} from 'react'
import { Form , Button , Card, Alert } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import { useAuth } from 'contexts/authContext'
import { Link  } from 'react-router-dom'
import Background from 'assets/img/d.jpg';

export default function ForgotPassword() {


  const emailRef = useRef()
  const { resetPassword } = useAuth()
  const [error,setError] = useState('')
  const [message,setMessage] = useState('')
  const [loading ,setLoading] = useState(false)
 

async function handleSubmit(e){
    e.preventDefault()
  
    try{

      setMessage('')  
      setError("")
      setLoading(true)
      await resetPassword(emailRef.current.value)
      setMessage('check your inbox for further instructions')
     

    }catch{
       setError('failed to reset password')
    }
    setLoading(false)
}


var sectionStyle = {
  // width: "100%",
  // height: "100%",
  backgroundSize: 'cover', 
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${Background})`
};

    return (
        <>
            
            <section style={ sectionStyle }>

        <container
        className = "d-flex align-items-center justify-content-center"
        style = {{minHeight: "100vh"}}
        >
            <div className="w-100" style = {{maxWidth:'400px'}}>
    
            <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Password Reset</h2>
          {/* {currentUser.email} */}
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}
          <Form  onSubmit={handleSubmit} >
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <br></br>
            <Button disabled={loading} className="w-100" type="submit">
              Reset Password
            </Button>
            <br></br>
            
          </Form>
          <div className="w-100 text-center mt-3">
        <Link to="/login">Login</Link>
      </div>

        </Card.Body>

        <br></br>
      </Card>
     
            

      </div>      
      </container>

</section>
        </>
    )
}
